import React, { useState } from "react";
import "./../assets/css/modal.css";
import Header from "../components/Header";
import Footer from "../components/Footer";
import bannerImage from "./../assets/banner/portada.jpg";
import imgVertical from "./../assets/banner/imgvertical.jpg";
import logvefase from "./../assets/banner/logo-negro.webp";
import { FaAccessibleIcon } from "react-icons/fa";
import Banner from "../components/Banner";
import AccessibilityModal from "./../components/AccessibilityModal";

const Nosotros = () => {
  const [showModal, setShowModal] = useState(false);

  const toggleModal = () => {
    setShowModal(!showModal);
  };

  return (
    <div className="micolor-jm">
      <Header />
      <button className="floating-button" onClick={toggleModal}>
      <img
               src={require("../assets/clientes/iconoaccesibilidad.jpg")}
              alt="Imagen vertical"
              className="img-vertical"
              style={{
                width: "50px",
                height:"50px",
              
              }}
            />
      </button>

      <AccessibilityModal isOpen={showModal} toggle={toggleModal} />

  
      
      <div className="container">
        <div className="row row-jm">
          <div className="col-md-6 col-sm-12 mt-5 mb-5">
            <h2 className="mt-4 sobre-nosotras-title">SOBRE NOSOTRAS</h2>
            <p className="mitexto">
              ¡Hola! Somos Carla y María Pía, arquitectas y especialistas en
              Accesibilidad Universal. Durante años hemos estado involucradas en
              proyectos relacionados con la accesibilidad en la ciudad,
              edificaciones y servicios. Nos conocimos a través de nuestras
              experiencias profesionales y descubrimos que compartimos la misma
              pasión y valores. Por ello, decidimos crear Hábitat Inclusión, una
              empresa comprometida con la mejora de los espacios y servicios en
              nuestras ciudades para que sean más inclusivas, seguras y
              accesibles para todos.
            </p>
           
          </div>
          

          <div className="col-md-6 col-sm-12">
            <img
              src={require("../assets/img/equipohabitat.jpg")}
              alt="Imagen vertical"
              className="img-vertical-nosotros"
            />
          </div>

          <div className="col-md-12 col-sm-12 mt-1 mb-5">
          <h2 className="mt-4 sobre-nosotras-title">EQUIPO HÁBITAT INCLUSIÓN
          </h2>
              <div className="mitexto text-center"> 
                  <p>Conoce al equipo multidisciplinario de Hábitat Inclusión, especialistas comprometidos con la creación de entornos accesibles y la promoción de una sociedad más inclusiva
                  </p>
              </div>
          </div>

          <div className="row">
            <div className="col-md-12 col-sm-12 ">
              <img
                src={require("../assets/img/trabajadores.png")}
                alt="Imagen vertical"
                style={{
                  width: "90%",
                }}
              />
            </div>
          </div>

          <div className="col-md-6 col-sm-12 mt-5 mb-5">
            <h2 className="mt-4 sobre-nosotras-title">NUESTROS VALORES</h2>
            <p className="mitexto3 ">
              <strong style={{fontWeight: 'bold', color: '#000000'}}>Inclusion</strong>
              <br></br>
              Consideramos importante la creación de espacios donde todas las
              voces son escuchadas y valoradas. Respetando las identidades y
              tendiendo puentes de diálogo.
              <br></br> <strong style={{fontWeight: 'bold', color: '#000000'}}>Innovación</strong>
              <br></br>
              Buscamos soluciones creativas y funcionales para mejorar la
              accesibilidad en todos los ámbitos.
              <br></br> <strong style={{fontWeight: 'bold', color: '#000000'}}>Colaboración</strong>
              <br></br>
              Trabajamos con empresas, comunidades y expertos para generar un
              impacto positivo y sostenible.
              <br></br>
              <strong style={{fontWeight: 'bold', color: '#000000'}}>Accesibilidad Universal </strong>
              <br></br>
              Creemos en la importancia de crear espacios y servicios para que
              todas las personas puedan hacer uso de ellos de forma cómoda,
              segura y autónoma.
              <br></br> <strong style={{fontWeight: 'bold', color: '#000000'}}>Responsabilidad Social</strong>
              <br></br>
              Nos comprometemos a educar, concientizar y transformar entornos
              para una sociedad más justa.
            </p>
          </div>

          

          <div className="col-md-6 col-sm-12 center-img">
            <img
              src={require("../assets/img/nuestrosvalores.jpg")}
              alt="Imagen vertical"
              style={{
                width: "100%",
                height: "auto",
                marginTop: "20%",
                objectFit: "contain",
              }}
            />
          </div>

          <div className="col-md-12 col-sm-12 mt-5 mb-5">
            <h2 className="mt-4 sobre-nosotras-title">
               OBJETIVOS ESTRATÉGICOS
            </h2>
            <div className="row">
              <div className="col-md-4 col-sm-12">
                <p className="mitexto">
                <strong style={{fontWeight: 'bold', color: '#000000'}}>Accesibilidad Universal </strong>
                <br></br>
                Implementamos la accesibilidad en edificaciones  empresas mediante planes personalizados y teniendo en cuenta la normativa nacional e internacional.
                <br></br> <br></br> <strong style={{fontWeight: 'bold', color: '#000000'}}>Fomentar una cultura organizacional inclusiva
                  
                </strong>
                
                <br></br>
                Concientizar a los trabajadores sobre la importancia de la inclusión y accesibilidad, incluyendo en la cultura organizacional de la empresa el respeto por la diversidad e igualdad.
               


                </p>
              </div>
              <div className="col-md-4 col-sm-12">
                <img
                  src={require("../assets/img/flecha.png")}
                  alt="Imagen vertical"
                  style={{
                    width: "90%",
                    height: "60%",
                    marginTop: "20%",
                  }}
                />
              </div>
              <div className="col-md-4 col-sm-12">
                <p className="mitexto">
                <strong style={{fontWeight: 'bold', color: '#000000'}}>Cumplimiento Normativo
                </strong>
                <br></br>
                Asesoramos a empresas en el cumplimiento de la normativa vigente en accesibilidad e inclusión, garantizando la implementación de las medidas necesarias para su funcionamiento.
                <br></br>
                <br></br> <strong style={{fontWeight: 'bold', color: '#000000'}}>Innovación en los proyectos

                </strong>
                <br></br> Desarrollamos soluciones que fomenten entornos inclusivos y fortalezcan la imagen corporativa de nuestros clientes. 
               

                </p>
              </div>
            </div>
          </div>

          <div className="col-md-6 col-sm-12 mt-5 mb-5">
            <h2 className="mt-4 sobre-nosotras-title">
              ¿POR QUÉ HÁBITAT INCLUSIÓN?
            </h2>
            <p className="mitexto">
              Nos llamamos Hábitat Inclusión porque creemos en implementar
              soluciones que permitan a todas las personas disfrutar plenamente
              del entorno urbano, edificaciones y servicios. La arquitectura
              organiza los espacios para hacerlos habitables, y un hábitat es el
              lugar con las condiciones adecuadas para la vida. Sabemos que las
              personas somos diversas y tenemos diferentes necesidades, razón
              por la cual el espacio que habitamos debe adaptarse a esas
              realidades. Nuestro objetivo es crear espacios y soluciones que
              cubran todas las necesidades para garantizar una vida plena.
              Estamos comprometidos con promover una sociedad más inclusiva,
              segura y accesible para todos
            </p>
           
          </div>
          <div className="col-md-6 col-sm-12 center-img">
            <img
              src={require("../assets/home/lima.jpg")}
              alt="Imagen vertical"
              style={{
                width: "90%",
                height: "50%",
                marginTop: "20%",
              }}
            />
          </div>

          <div className="col-md-12 col-sm-12 mt-5 mb-5"></div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Nosotros;
